import { Routes } from '@angular/router';
import { eventGuard } from '@shared/event-guard';
import { isLoggedInGuard } from '@shared/is-logged-in-guard';

import { canAbilityGuard } from './shared/permissions/can.guard';

export const routes: Routes = [
  {
    path: 'start',
    loadChildren: () => import('./start/start.routes').then(m => m.routes),
  },
  {
    path: '',
    canActivate: [isLoggedInGuard, eventGuard],
    children: [
      {
        path: 'config',
        loadChildren: () => import('./app-config/app-config.routes').then(m => m.routes),
        canActivate: [canAbilityGuard('read', 'config')],
      },
      {
        path: 'event',
        loadChildren: () => import('./event/event.routes').then(m => m.routes),
        canActivate: [canAbilityGuard('read', 'event')],
      },
      {
        path: 'participant',
        loadChildren: () => import('./participant/participant.routes').then(m => m.routes),
        canActivate: [canAbilityGuard('read', 'participant')],
      },
      {
        path: 'pushmessage',
        loadChildren: () => import('./push-message/push-message.routes').then(m => m.routes),
        canActivate: [canAbilityGuard('read', 'pushMessage')],
      },
      {
        path: 'taskmanagement',
        loadComponent: () => import('./task-management/task-management.page').then(m => m.TaskManagementPage),
        canActivate: [canAbilityGuard('read', 'taskManagement')],
      },
      {
        path: 'team',
        loadChildren: () => import('./team/team.routes').then(m => m.routes),
        canActivate: [canAbilityGuard('read', 'team')],
      },
      {
        path: 'translation',
        loadChildren: () => import('./translation/translation.routes').then(m => m.routes),
        canActivate: [canAbilityGuard('read', 'translation')],
      },
      {
        path: 'image-management',
        loadChildren: () => import('./image-management/image-management.routes').then(m => m.routes),
        canActivate: [canAbilityGuard('read', 'imageManagement')],
      },
    ],
  },
  { path: 'signin-callback', redirectTo: 'participant', pathMatch: 'full' },
  { path: 'signout-callback', redirectTo: 'start', pathMatch: 'full' },
];
